import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3>{t('companyName')}</h3>
            <p>{t('companyDescription')}</p>
            <div className="social-links">
              <a href="https://www.facebook.com/share/19yS33wkjp/" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>

              <a href="https://www.instagram.com/ramson_feeds/" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>

              <a href="https://www.linkedin.com/company/ramson-feeds/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
          
          <div className="footer-column">
            <h3>{t('quickLinks')}</h3>
            <ul className="footer-links">
              <li><Link to="/">{t('home')}</Link></li>
              <li><Link to="/about">{t('about')}</Link></li>
              {/* <li><Link to="/gallery">{t('gallery')}</Link></li> */}
              <li><Link to="/products">{t('products')}</Link></li>
              <li><Link to="/contact">{t('contact')}</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3>{t('ourProducts')}</h3>
            <ul className="footer-links">
              <li><Link to="/products">{t('cattleFeed')}</Link></li>
              <li><Link to="/products">{t('rawMaterials')}</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3>{t('contactInfo')}</h3>
            <div className="contact-info">
              <p><i className="fas fa-map-marker-alt" style={{paddingTop: "18px"}}></i> 37/2, Elumalai Gounder Vattam <br></br>Kandampatty, Salem-636005</p>
              <p><i className="fas fa-phone" style={{paddingTop: "7px"}}></i> +91 9443245877</p>
              <p><i className="fas fa-envelope" style={{paddingTop: "5px"}}></i> ramsonfeedssalem@gmail.com</p>
              <p><strong>GST Number:</strong>&nbsp;33AHJPR4783K2ZQ</p>
            </div>
          </div>
        </div>
        
        <div className="copyright">
          <p>&copy; 2025 {t('companyName')}. {t('rightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;